import { render, staticRenderFns } from "./PriceChangeFilter.vue?vue&type=template&id=06a92562&scoped=true&"
import script from "./PriceChangeFilter.vue?vue&type=script&lang=js&"
export * from "./PriceChangeFilter.vue?vue&type=script&lang=js&"
import style0 from "./PriceChangeFilter.vue?vue&type=style&index=0&id=06a92562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a92562",
  null
  
)

export default component.exports